<template>
  <v-dialog
    v-model="localDialog"
    width="40%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>Tax Adjustment</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="SaleInvoiceTaxAdjustment">
          <v-row>
            <v-col lg="12" md="12" cols="12">
              <v-date-input
                input-format="dd/mm/yyyy"
                density="compact"
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="adjustment_date.value.value"
                :error-messages="adjustment_date.errorMessage.value"
                autocomplete="off"
                clearable
              >
                <template #label>
                  Adjustment Date <span class="text-red-accent-4">*</span>
                </template>
              </v-date-input>
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                type="number"
                step="0.01"
                v-model="amount.value.value"
                :error-messages="amount.errorMessage.value"
                clearable
              >
                <template #label>
                  Amount <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
            </v-col>

            <input v-model="sale_invoice_id.value.value" type="hidden" />
          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                Save
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "SaleInvoiceTaxAdjustment",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        sale_invoice_id: "",
        adjustment_date: "",
        amount: "",
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.resetForm({ errors: {}, touched: {} });
        this.sale_invoice_id.setValue(newData.sale_invoice_id || "", false);
        this.adjustment_date.setValue(newData.adjustment_date || "", false);
        this.amount.setValue(newData.amount || "", false);
      },
      deep: true,
    },
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        sale_invoice_id: yup.number().required().label("Invoice"),
        adjustment_date: yup.string().required().trim().label("Adjustment Date"),
        amount: yup.number().typeError("Amount is required").required().label("Amount"),
      }),
    });

    const sale_invoice_id = useField("sale_invoice_id");
    const adjustment_date = useField("adjustment_date");
    const amount = useField("amount");
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.adjustment_date = formattedDate(adjustment_date.value.value);

      store
        .dispatch("saveUpdateSaleInvoiceTaxAdjustment", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          store
            .dispatch("getSaleInvoiceList")
            .then((data) => {
              return data;
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submit,
      sale_invoice_id,
      adjustment_date,
      amount,
      resetForm,
    };
  },
};
</script>
